export const DEFAULT_DURATION = 5000
export const LONG_DURATION = 10000
